import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { resources } from '../data/programs';

const { FiExternalLink, FiShield, FiInfo } = FiIcons;

const locationLinks = [
  { name: 'Houston', url: 'https://ptaprogramsinhouston.com/' },
  { name: 'San Antonio', url: 'https://ptaprogramssanantonio.com/' },
  { name: 'Oklahoma', url: 'https://ptaprogramsoklahoma.com/' },
  { name: 'North Carolina', url: 'https://ptaprogramsnorthcarolina.com/' },
  { name: 'San Diego', url: 'https://ptaprogramssandiego.com/' },
  { name: 'Dallas', url: 'https://ptaprogramsdallas.com/' },
  { name: 'Tampa', url: 'https://ptaprogramstampa.com/' },
  { name: 'Sacramento', url: 'https://ptaprogramssacramento.com/' },
  { name: 'Orlando', url: 'https://ptaprogramsorlando.com/' },
  { name: 'PTASchoolsNearMe.com', url: 'https://ptaschoolsnearme.com/' },
];

function Resources() {
  const allResources = [
    {
      title: 'The PTA Guide',
      description:
        'The best online resource for aspiring physical therapist assistants to compare programs nearby and online.',
      url: 'https://physical-therapy-assistant.org/',
    },
    ...resources,
  ];

  return (
    <footer className="resources">
      <div className="section">
        <div className="section-heading align-left">
          <p className="eyebrow">Trusted references</p>
          <h2>Explore PTA Career Resources</h2>
          <p>
            Use authoritative sources to understand PTA education, accreditation,
            clinical practice, licensure, professional standards, and career
            planning.
          </p>
          <p>
            Before applying, compare official program information with your
            goals. Ask about prerequisites, accreditation, clinical education,
            total costs, graduation outcomes, licensure preparation, and
            available student support.
          </p>
        </div>
        <div className="resource-list">
          {allResources.map((resource) => (
            <a
              href={resource.url}
              target="_blank"
              rel="noreferrer"
              key={resource.title}
            >
              <span className="resource-icon">
                <SafeIcon icon={FiExternalLink} />
              </span>
              <span>
                <strong>{resource.title}</strong>
                <small>{resource.description}</small>
              </span>
            </a>
          ))}
        </div>
        <div className="disclaimer">
          <SafeIcon icon={FiInfo} />
          <p>
            This independent directory is for educational research. It is not a
            college, does not guarantee admission or employment, and does not
            provide licensing advice. Program availability, accreditation,
            pricing, schedules, credentials, and licensing requirements can
            change. Verify every important detail directly with the school and
            the relevant California licensing authority.
          </p>
        </div>
        <div className="footer-bottom">
          <span className="footer-brand">
            <SafeIcon icon={FiShield} />
            <a href="/" aria-label="PTA Programs Los Angeles home page">
              PTA Programs Los Angeles
            </a>
          </span>
          <div className="footer-links">
            <span aria-hidden="true">·</span>
            <a href="/privacy-policy">Privacy Policy</a>
            <span aria-hidden="true">·</span>
            <a href="/sitemap.xml">Sitemap</a>
            <span>© 2026 All rights reserved.</span>
          </div>
        </div>
        <nav
          className="location-navigation"
          aria-label="PTA programs by location"
        >
          <span>View PTA programs in other locations: </span>
          {locationLinks.map((location, index) => (
            <span key={location.name}>
              <a href={location.url} target="_blank" rel="noreferrer">
                {location.name}
              </a>
              {index < locationLinks.length - 1 ? ', ' : ''}
            </span>
          ))}
        </nav>
      </div>
    </footer>
  );
}

export default Resources;